import RoutesService from './routes-service';
import Route from '../components/routes/route.js';

export default class RoutesServiceNY extends RoutesService {
    constructor(map) {
        super(map);
        this.oid = 'newyear';
        this.routesBuffer = [];
        this.hasNewTrack = false;
        this.tracks = [];
        this.playbackIcon = {};
        this.playbackIconLeft = {};
        this.tm = null;
    }

    clearRoutes_ny() {
        clearTimeout(this.tm);
        for (let i = 0; i < this.tracks.length; i++) {
            this.clearRoute_ny(this.oid+i);
        }        
    }

    setRoutesOnMap_ny(tracks, playbackIcon, isBound, playbackIconLeft) {
        let i = 0;
        this.playbackIcon = {...playbackIcon};
        this.playbackIconLeft = {...playbackIconLeft};
        let bounds = [];
        tracks.forEach( track => {
            bounds.push(this.setRouteOnMap_ny({
                fuelings: null,
                stops: null,
                track: {
                    coords: [...track.points],
                    oid: this.oid + i,
                    photos: null,
                    result: "Ok",
                    sensors: []                    
                },
                color: track.color,
                playbackIconLeft: playbackIconLeft.iconUrl,
            }, {...playbackIcon}));
            i++;
        });

        if (isBound) {
            let bound = {
                maxLat: bounds[0].getSouthEast().lat,
                maxLng: bounds[0].getSouthEast().lng,
                minLat: bounds[0].getNorthWest().lat,
                minLng: bounds[0].getNorthWest().lng   
            };

            bounds.forEach( b => {
                if (b && b.getSouthEast().lat > bound.maxLat) {
                    bound.maxLat = b.getSouthEast().lat;
                }
                if (b && b.getSouthEast().lng > bound.maxLng) {
                    bound.maxLng = b.getSouthEast().lng;
                }
                if (b && b.getNorthWest().lat < bound.minLat) {
                    bound.minLat = b.getNorthWest().lat;
                }
                if (b && b.getNorthWest().lng < bound.minLng) {
                    bound.minLng = b.getNorthWest().lng;
                }              
            });

            let boundsGlobal = L.latLngBounds(L.latLng(bound.minLat, bound.minLng), L.latLng(bound.maxLat, bound.maxLng));
            this.map.fitBounds(boundsGlobal, {padding: [100, 100]});
        }

        this.tracks = [...tracks];
        this.playHappyNewYear(0);
    }

    updateRoutesOnMap_ny(tracks, playbackIcon, playbackIconLeft) {
        let lastNumber = tracks.length - 1;

        if(this.routesDictionary[this.oid+lastNumber]) {
            this.playbackIcon = {...playbackIcon};            
            this.routesBuffer.push(tracks);
        } else {
            const hideTrackIcons = true;
            const route = new Route(
                {
                    coords: [...tracks[lastNumber].points],
                    oid: this.oid + lastNumber,
                    photos: null,
                    result: "Ok",
                    sensors: []                    
                },
                this.map,
                tracks[lastNumber].color,
                hideTrackIcons,
                {...playbackIcon}
            );
            this.routesDictionary[this.oid+lastNumber] = route;
            route.playback.hideMarker();
            route.playback.setIcons(playbackIcon.iconUrl, playbackIconLeft.iconUrl);
            this.tracks = [...tracks];
            this.hasNewTrack = true;
        }
    }

    clearRoute_ny(oid) {
        if (this.routesDictionary[oid]) {
            this.currentRouteColorIndex = this.routesDictionary[oid].clear(this.currentRouteColorIndex);
            delete this.routesDictionary[oid];
        };
    }

    isTrackPlaying(playback, currentNumber) {
        const SELF = this;
        return new Promise( (resolve, reject) => {

            function checkPlayback () {
                if (Object.keys( SELF.routesDictionary ).length > 0) {
                    if (playback.getTime() < playback.getEndTime()) {
                        this.tm = setTimeout(checkPlayback, 1000);
                    }else {
                        playback.stop();
                        const lastIndex = Object.keys( SELF.routesDictionary ).length - 1;
                        if (SELF.routesBuffer.length > 0 ) {
                            SELF.clearRoute_ny(SELF.oid + lastIndex);
                            const tracks = SELF.routesBuffer.pop();
                            SELF.routesBuffer.length = 0;

                            let lastNumber = tracks.length - 1;
                            const hideTrackIcons = true;
                            const route = new Route(
                                {
                                    coords: [...tracks[lastNumber].points],
                                    oid: SELF.oid + lastNumber,
                                    photos: null,
                                    result: "Ok",
                                    sensors: []                    
                                },
                                SELF.map,
                                tracks[lastNumber].color,
                                hideTrackIcons,
                                {...SELF.playbackIcon}
                            );
                            route.playback.hideMarker();
                            route.playback.setIcons(SELF.playbackIcon.iconUrl, SELF.playbackIconLeft.iconUrl);

                            SELF.routesDictionary[SELF.oid + lastIndex] = route;
                        }
                        if (SELF.hasNewTrack) {
                            SELF.hasNewTrack = false;
                            reject(currentNumber);
                        } else {
                            resolve();
                        }
                    }
                }
            }
            
            setTimeout( checkPlayback, 1000);
        });
    }

    playHappyNewYear (startIndex) {
        const speed = 400;
        const maxIterations = 600*this.tracks.length;
        let p = Promise.resolve();
        for(let i=startIndex;i < maxIterations; i++) {
            p = p.then(() => {
                const currentNumber = i%this.tracks.length;
                const playback = this.routesDictionary[this.oid+currentNumber].playback;
                if (i > 0) {
                    const j = (i - 1)%this.tracks.length;
                    this.routesDictionary[this.oid+j].playback.hideMarker();
                }
                playback.setCursor(playback.getStartTime());
                playback.showMarker();
                playback.start();
                playback.setSpeed(speed);
                return this.isTrackPlaying(playback, currentNumber);
            }, (currentNumber) => {
                return Promise.reject(currentNumber);
            });
        }
        p = p.catch((currentNumber) => {
            this.playHappyNewYear(currentNumber + 1);
        });
    }

    setRouteOnMap_ny(routeInfo, playbackIcon) {
        if (typeof routeInfo == 'undefined' || !routeInfo.track || routeInfo.track.result != 'Ok'
            || (routeInfo.track.coords.length === 0)
        ) {
            return;
        }

        let route;

        if (routeInfo.track && routeInfo.track.result == 'Ok' && routeInfo.track.coords.length > 0) {
            const hideTrackIcons = true;
            route = new Route(
                routeInfo.track,
                this.map,
                routeInfo.color,
                hideTrackIcons,
                {...playbackIcon}
            );
            this.updateCurrentColorIndex();
            this.routesDictionary[routeInfo.track.oid] = route;
            route.playback.hideMarker();
            route.playback.setIcons(playbackIcon.iconUrl, routeInfo.playbackIconLeft);
            this.selectedRouteId = routeInfo.track.oid;
        }

        let bounds = null;

        if (route) {
            bounds = route.routeLayer.getBounds();
            if (!bounds.isValid()) {
                bounds = route.markersLayer.getBounds();
            }
        }

        return bounds;
    }
}